const enum HardwareType {
    BEACON = 'beacon',
    PHYSICAL_OBJECT = 'physical-object',
    QR_CODE = 'qr-code',
    INTERACTION_AREA = 'interaction-area',
    ZONE = 'zone',
    UNKNOWN = 'unknown'
}

export default HardwareType